<template>
    <div>
        <app-sub-title text="Filtros" />
        <b-card>
            <div class="card-text">
                <b-row>
                    <b-col cols="12" md="3" lg="3">
                        <app-autocomplete
                            placeholder="Cliente"
                            :items="clients"
                            v-model="selectClient"
                        />
                    </b-col>
                    <b-col cols="12" md="3" lg="3">
                        <app-autocomplete
                            placeholder="Supervisor"
                            :items="authors"
                            v-model="selectSupervisor"
                        /> 
                    </b-col>
                    <b-col cols="12" md="2" lg="2">
                        <app-years-select-input :label="false" :placeholder="true" v-model="filters.year"/>
                    </b-col>
                    <b-col cols="12" md="2" lg="2">
                        <app-months-select-input v-model="filters.month" :label="false" :placeholder="true" />
                    </b-col>
                    <b-col cols="12" md="1" lg="1">
                        <b-button variant="primary" class="btn-block" @click="$emit('filter', filters)"><i class="fa fa-filter"></i></b-button>
                    </b-col>
                    <b-col cols="12" md="1" lg="1">
                        <b-button variant="secondary" class="btn-block" @click="clearFilters"><i class="fa fa-times-circle"></i></b-button>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
</template>
<script>
import Autocomplete from '../../../../UI/Controls/AutocompleteV2/Autocomplete.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        appAutocomplete: Autocomplete
    },
    props: {
        authors: {
            type: Array
        }
    },
    data(){
        return {
            filters: {
                user: '',
                client: '',
                month: '',
                year: ''
            },
            selectClient: '',
            selectSupervisor: ''
        }
    },
    watch:{
        selectClient(val){
            if(!val){
                this.filters.client= '';
                this.selectClient = '';
            }else{
                this.filters.client = val.id;
            }
        },
        selectSupervisor(val){
            if(!val){
                this.filters.author= '';
                this.selectSupervisor = '';
            }else{
                this.filters.author = val.id;
            }
        }
    },
    computed: {
        ...mapGetters(['clients'])
    },
    methods: {
        clearFilters(){
            this.selectClient= '';
            this.selectSupervisor = '';
            Object.keys(this.filters).map(key => this.filters[key] = '');
            this.$emit('filter', null);
        }
    },
    created() {
        this.load('clients');
        this.load('years');
        this.load('months');
    }
}
</script>

